import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Row, Col, Card, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { CustomDataTable } from '../../../../components/design/Datatables/CustomDataTable'
import useAuth from '../../../../context/auth/useAuth'
import Loader from '../../../../components/design/Loader/Loader'
import { getInvitationsByClub, getTickets } from '../../../../actions/ticketing/ticketsActions'
import ClubBreadCrumbs from '../../../../components/breadcrumbs/ClubBreadCrumbs'
import TicketingSubMenu from '../../../../components/menus/TicketingSubMenu'
import Swal from 'sweetalert2'
import AddInvitation from '../../../../components/ticketing/AddInvitation'
import { sendEmailDownloadInvitation } from '../../../../actions/downloads/downloadsActions'
import InvitationSummary from '../../../../components/ticketing/InvitationSummary'

export default function Invitations({usertype, isAdmin = false}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
	const {clientauth} = useAuth()

    const {tickets, loading, result} = useSelector(state=>state.ticket)
    const {resultdownload} = useSelector(state=>state.downloads)
    const {club} = useSelector(state=>state.clubs)

    const [invitationSelected, setInvitationSelected] = useState(null)
    const [formType, setFormType] = useState(null)

    const [addInvitation, setAddInvitation] = useState(false)

    const handleSendEmail = (ticketId) => {
        dispatch(sendEmailDownloadInvitation(ticketId))
    }

	const columnsTickets = [
        {
            name: t('tickets.match'),
            cell: ticket =>
                <div>
                    <div className='fw-bold'>{`${ticket.match.host} - ${ticket.match.visitor}`}</div>
                    <div><small>{`${new Date(ticket.match.date).toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year: 'numeric'})} ${ticket.match.hour}`}</small></div>
                </div>,
            selector: (ticket) => `${ticket.match.host} - ${ticket.match.visitor} ${new Date(ticket.match.date).toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year: 'numeric'})} ${ticket.match.hour}`,
            sortable: true,
        },{
            name: t('tickets.sector'),
            cell: ticket =>
                ticket.sector.name,
            selector: (ticket) => ticket.sector.name,
            sortable: true,
        },{
            name: t('tickets.status'),
            center: 'true',
            cell: ticket =>
                ticket.status === 0 ? t('tickets.pending') :
                ticket.status === 1 ? t('tickets.active') :
                ticket.status === 2 ? t('tickets.canceled') :
                t('tickets.unknown'),
            selector: (ticket) =>
                ticket.status === 0 ? t('tickets.pending') :
                ticket.status === 1 ? t('tickets.active') :
                ticket.status === 2 ? t('tickets.canceled') :
                t('tickets.unknown'),
            sortable: true,
        },{
            name: t('tickets.client'),
            cell: ticket => (
                <div>
                    <span>{`${ticket.firstname} ${ticket.lastname || ''}`}</span>
                    <br />
                    <small>{ticket.email} {ticket.phone || ''}</small>
                </div>
            ),
            selector: (ticket) => `${ticket.firstname} ${ticket.lastname || ''} ${ticket.email} ${ticket.phone || ''}`,
            sortable: true,
        },
        {
            name: t('global.actions'),
            center: 'true',
            cell: ticket =>
                <div className='d-flex w-100 justify-content-center'>
                    <div
                        onClick={() => {
                            setInvitationSelected(ticket)
                            setFormType("view")
                        }}
                        className='table-link me-2'>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">{t('tickets.seeTicket')}</Tooltip>}
                        >
                            <img className="cursor" src="/images/eyeopen.svg" alt="eyes" height={16}/>
                        </OverlayTrigger>
                    </div>
                    <div
                        onClick={() => {
                            handleSendEmail(ticket.firstTicket)
                        }}
                        className='table-link me-2'>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">{t('tickets.sendemail')}</Tooltip>}
                        >
                            {/* <img src="/images/envelope.svg" alt="Email" className='me-2 my-2' /> */}
                            <i className='far fa-envelope'></i>
                        </OverlayTrigger>
                    </div>
                    <div
                        onClick={() => {
                            setInvitationSelected(ticket)
                            setFormType("edit")
                        }}
                        className='table-link'>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">{t('tickets.editTicket')}</Tooltip>}
                        >
                            <img className="cursor" src="/images/pencil.svg" alt="pencil" height={16}/>
                        </OverlayTrigger>
                    </div>
                </div>,
            sortable: false,
        }
	]

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if (isAdmin) {
            dispatch(getTickets())
        } else {
            if(club){
                dispatch(getInvitationsByClub(club._id))
            }
        }
        // eslint-disable-next-line
    },[dispatch, t, clientauth])

    useEffect(() => {
        if (result) {
            switch (result) {
                case 'changeStatusSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('tickets.changeStatusSuccess')
                    })
                    setInvitationSelected(null)
                    setFormType(null)
                    dispatch(getInvitationsByClub(club._id))
                    dispatch({ type: "TICKET_CHANGE_STATUS_RESET" })
                    break;
                default:
                    break;
            }
        }
    }, [result, club, dispatch, t])

    useEffect(() => {
        if (resultdownload) {
            switch (resultdownload) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('passes.emailsendsuccess')
                    })
                    break;
                case 'notentryexist':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('passes.notentryexist')
                    })
                    break;
                case 'notemailexist':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('passes.notemailexist')
                    })
                    break;
                default:
                    break;
            }
            dispatch({type: 'DOWNLOAD_RESET_RESULT'})
        }
    }, [resultdownload, t, dispatch])

    return (
        <Container className='cuerpo'>
            {
                isAdmin
                ?
                    <Row>
                        <Col className='d-flex align-items-center'>
                            <h1>{t('menus.ticketing.invitations')}</h1>
                        </Col>
                    </Row>
                :
                <>
                    <ClubBreadCrumbs usertype={usertype} club={club} />
                    <Row className="my-3">
                        <Col>
                            <TicketingSubMenu usertype={usertype} active="invitations"/>
                        </Col>
                    </Row>
                </>
            }
            <Row className='my-3'>
                <Col>
                    <Card>
                        <Card.Body>
                            <div className='d-flex justify-content-between align-items-end'>
                                <h2>{t('tickets.invitationsList')}</h2>
                                <div>
                                    <Button variant="secondary" type="button" className='ms-2' onClick={() => setAddInvitation(true)}>
                                        <i className='fas fa-plus'/> {t('tickets.addInvitation')}
                                    </Button>
                                </div>
                            </div>
                            <hr className='mb-4'/>
                            <div className='my-3'>
                                <Row>
                                    <Col>
                                        {
                                            loading
                                                ?
                                                    <Loader/>
                                                :
                                                    <>
                                                        {
                                                            tickets?.length > 0 ?
                                                                <CustomDataTable
                                                                    columns={columnsTickets}
                                                                    data={tickets}
                                                                    exportable={false}
                                                                    printable={false}
                                                                />
                                                            :
                                                                <div className='contenedor-vacio text-center'>
                                                                    <h4>{t('tickets.noTickets')}</h4>
                                                                    {t('tickets.thereIsNoTicketsPhrase')}
                                                                </div>
                                                        }
                                                    </>
                                        }
                                        
                                    </Col>
                                </Row>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <InvitationSummary invitationSelected={invitationSelected} closeModal={() => setInvitationSelected(null)} formType={formType} usertype={usertype}/>
            <AddInvitation userType="club" closeModal={() => {setAddInvitation(false)}} show={addInvitation} club={club}/>
        </Container>
    )
}